<template>
  <avs-card
    noTitle
    disabled
  >
    <template v-slot:content>
      <v-card-title>{{ template.title }}</v-card-title>
      <v-card-subtitle v-html="template.description"></v-card-subtitle>

      <v-card-text
        v-for="(section, index) in template.sections"
        :key="index"
      >
        <h4>{{ section.title }}</h4>
        <span>{{ section.description }}</span>

        <component
          v-for="(field, idx) in section.fields"
          :key="idx"
          :is="field.type.component.name"
          v-bind="field.type.options"
          :label="field.name"
          :typename="field.type.name"
        />
      </v-card-text>
    </template>
  </avs-card>
</template>

<script>
import Checkbox from "@/components/ri3/documents/fieldtypes/Checkbox.vue"
import DateField from "@/components/ri3/documents/fieldtypes/DateField.vue"
import ImageField from "@/components/ri3/documents/fieldtypes/ImageField.vue"
import Selector from "@/components/ri3/documents/fieldtypes/Selector.vue"
import Table from "@/components/ri3/documents/fieldtypes/Table.vue"
import TextField from "@/components/ri3/documents/fieldtypes/TextField.vue"
import TextArea from "@/components/ri3/documents/fieldtypes/TextArea.vue"
import Break from "@/components/ri3/documents/fieldtypes/Break.vue"

export default {
  name: "TemplatePreview",
  components: { Checkbox, DateField, ImageField, Selector, Table, TextField, TextArea, Break },
  props: {
    template: {
      type: Object
    }
  }
}
</script>
